import { PropsWithChildren, useEffect, useRef } from 'react';
import { useDroppable } from '@dnd-kit/core';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { routineActivitiesWrapperSelector } from 'store/reducer/setting/selectors';
import { resetIsNewHabitAppended } from 'store/reducer/setting/slice';
import { ROUTINE_DROPPABLE_ID } from 'constants/routine-suggestions-revamp';

const RoutineActivitiesWrapperRevamp = ({ children }: PropsWithChildren) => {
  const dispatch = useAppDispatch();
  const dummyDiv = useRef<HTMLDivElement>(null);
  const isNewHabitAppended = useAppSelectorShallow(routineActivitiesWrapperSelector);
  const { setNodeRef } = useDroppable({ id: ROUTINE_DROPPABLE_ID.MORNING });

  useEffect(() => {
    if (isNewHabitAppended) {
      dummyDiv.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
      dispatch(resetIsNewHabitAppended());
    }
  }, [isNewHabitAppended, dispatch]);

  return (
    <div
      className='w-full h-full max-h-full ~mt-1/2 py-1 flex flex-col ~gap-4/6 overflow-y-auto scrollbar-thin scrollbar-thumb-primary-500 scrollbar-track-transparent'
      ref={setNodeRef}
      data-testid='routine-activities-wrapper-revamp'
    >
      {children}
      <div className='float-left clear-both' ref={dummyDiv}></div>
    </div>
  );
};

export default RoutineActivitiesWrapperRevamp;
